import { Button } from "shared/ui/button";
import { useHttpRequest } from "shared/lib/hooks/useHttpRequest";
import { eventRegisterRequest } from "../api/eventRegisterRequest";
import { useSidebar } from "shared/lib/hooks";
import { LoginSidebar } from "widgets";
import { useUserStore } from "entities/user/hooks/useUserStore";

export const EventRegistrationButton = ({ variant, openModal }) => {
  const { sendRequest, loading, error, clearError } =
    useHttpRequest(eventRegisterRequest);

  const { isAuthenticated, user } = useUserStore();

  const eventId = "123e4567-e89b-12d3-a456-426614174000";

  const {
    isCollapsed: isLoginSidebarCollapsed,
    open: openLoginSidebar,
    close: closeLoginSidebar,
    toggle: toggleLoginSidebar,
  } = useSidebar(true);

  const handleClick = async (e) => {
    e.preventDefault();

    if (loading) return;

    if (!isAuthenticated || !user?.id) {
      openLoginSidebar();
      return;
    }

    try {
      await sendRequest({
        eventId: eventId,
        userId: user.id,
      });
      openModal();
    } catch (error) {
      const status = error?.status;

      if (status === 401) {
        openLoginSidebar();
        return;
      }

      if (status >= 500) {
        return;
      }
    }
  };

  return (
    <>
      <Button variant={variant} size="large" onClick={handleClick}>
        Зарегистрироваться
      </Button>
      <LoginSidebar
        isCollapsed={isLoginSidebarCollapsed}
        open={openLoginSidebar}
        close={closeLoginSidebar}
        toggle={toggleLoginSidebar}
        variant="eventPage"
      />
    </>
  );
};
